const SLACK_URL = process.env.SLACK_URL;

interface Payload {
  title?: string;
  author_name?: string;
  msg: string;
  footer?: string;
}

export const sendSlackNotification = (
  payload: Payload,
  ok: boolean,
): Promise<Response> => {
  console.trace("SLACK", JSON.stringify(payload, null, 2), ok);

  const {
    title = "ORDER_WEBHOOK",
    author_name = "TODO",
    msg = "NA",
    footer = "ZOL",
  } = payload;

  const pretext = typeof msg === "object" ? JSON.stringify(msg, null, 2) : msg;

  const request = {
    attachments: [
      {
        fallback: pretext,
        color: ok ? '#11AA22' : '#EE3355',
        author_name,
        title,
        pretext,
        // fields: [{ title: "Priority", value: "High", short: false }],
        footer,
      },
    ],
  };
  console.trace("SLACK::DONE", JSON.stringify(request, null, 2));

  return fetch(SLACK_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(request),
  });
};
